
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const NosotrosPage = lazy(() => import('../pages/nosotros/page'));
const FullDayPage = lazy(() => import('../pages/servicios/fullday/page'));
const RestaurantePage = lazy(() => import('../pages/servicios/restaurante/page'));
const EventosPage = lazy(() => import('../pages/servicios/eventos/page'));
const MembresiasPage = lazy(() => import('../pages/servicios/membresias/page'));
const BungalowsPage = lazy(() => import('../pages/servicios/bungalows/page'));
const SedesPage = lazy(() => import('../pages/sedes/page'));
const ContactoPage = lazy(() => import('../pages/contacto/page'));
const TerminosPage = lazy(() => import('../pages/terminos/page'));
const PrivacidadPage = lazy(() => import('../pages/privacidad/page'));
const CookiesPage = lazy(() => import('../pages/cookies/page'));
const ReglamentoInternoPage = lazy(() => import('../pages/reglamento-interno/page'));
const ReglamentoSociosPage = lazy(() => import('../pages/reglamento-interno/socios/page'));
const LibroReclamacionesPage = lazy(() => import('../pages/libro-reclamaciones/page'));
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminDashboard = lazy(() => import('../pages/admin/AdminDashboard'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/nosotros',
    element: <NosotrosPage />,
  },
  {
    path: '/servicios/fullday',
    element: <FullDayPage />,
  },
  {
    path: '/servicios/restaurante',
    element: <RestaurantePage />,
  },
  {
    path: '/servicios/eventos',
    element: <EventosPage />,
  },
  {
    path: '/servicios/membresias',
    element: <MembresiasPage />,
  },
  {
    path: '/servicios/bungalows',
    element: <BungalowsPage />,
  },
  {
    path: '/sedes',
    element: <SedesPage />,
  },
  {
    path: '/contactanos',
    element: <ContactoPage />,
  },
  {
    path: '/terminos',
    element: <TerminosPage />,
  },
  {
    path: '/privacidad',
    element: <PrivacidadPage />,
  },
  {
    path: '/cookies',
    element: <CookiesPage />,
  },
  {
    path: '/reglamento-interno',
    element: <ReglamentoInternoPage />,
  },
  {
    path: '/reglamento-interno/socios',
    element: <ReglamentoSociosPage />,
  },
  {
    path: '/libro-reclamaciones',
    element: <LibroReclamacionesPage />,
  },
  {
    path: '/admin',
    element: <AdminDashboard />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboard />,
  },
  {
    path: '/admin/contactanos',
    element: <AdminDashboard />,
  },
  {
    path: '/admin/reclamaciones',
    element: <AdminDashboard />,
  },
  {
    path: '/admin/usuarios',
    element: <AdminDashboard />,
  },
  {
    path: '/admin/modales',
    element: <AdminDashboard />,
  },
  {
    path: '/admin/membresias',
    element: <AdminDashboard />,
  },
  {
    path: '/admin/fullday',
    element: <AdminDashboard />,
  },
  {
    path: '/admin/eventos',
    element: <AdminDashboard />,
  },
  {
    path: '/admin/seo',
    element: <AdminDashboard />,
  },
  {
    path: '/admin/tracking',
    element: <AdminDashboard />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
